import { canAccessFeature } from "../auth/packageAccess";

function visible(session, links) {
  return links.filter((link) => !link.feature || canAccessFeature(session, link.feature));
}

/** Agent console navigation — filtered by Agent Standard (or Beta) entitlements. */
export function agentNavLinks(session) {
  return visible(session, [
    { to: "/agent/dashboard", label: "Dashboard", feature: "agent_desk" },
    { to: "/agent/clients", label: "Client Manager", feature: "client_manager" },
    { to: "/agent/prospects", label: "Prospects", feature: "prospects" },
    { to: "/agent/files", label: "Files", feature: "files" },
    { to: "/agent/documents", label: "Documents & Photos", feature: "documents" },
    { to: "/agent/responses", label: "Inquiry/Response", feature: "client_manager" },
    { to: "/agent/messages", label: "Client Messaging", feature: "client_messaging", unread: "client" },
    { to: "/agent/office", label: "Office Messaging", feature: "office_messaging", unread: "office" },
    { to: "/agent/calendar", label: "Calendar", feature: "calendar" },
    { to: "/agent/hub/hall", label: "The Hub", feature: "hub", unread: "hub" },
    { to: "/agent/settings", label: "Profile/Settings", feature: "agent_desk" },
  ]);
}

/** Broker office navigation — filtered by Broker Office / Enterprise entitlements. */
export function brokerNavLinks(session) {
  return visible(session, [
    { to: "/broker/dashboard", label: "Dashboard", end: true, feature: "broker_desk" },
    { to: "/broker/clients", label: "Client Manager", feature: "client_manager" },
    { to: "/broker/prospects", label: "Prospects", feature: "prospects" },
    { to: "/broker/files", label: "Files", feature: "files" },
    { to: "/broker/documents", label: "Documents & Photos", feature: "documents" },
    { to: "/broker/responses", label: "Inquiry/Response", feature: "client_manager" },
    { to: "/broker/messages", label: "Client Messaging", end: true, feature: "client_messaging", unread: "client" },
    { to: "/broker/office", label: "Office Messaging", feature: "office_messaging", unread: "office" },
    { to: "/broker/calendar", label: "Calendar", feature: "calendar" },
    { to: "/broker/hub/hall", label: "The Hub", feature: "hub", unread: "hub" },
    { to: "/broker/profile", label: "Profile", feature: "broker_desk" },
    { to: "/broker/settings", label: "Settings", feature: "broker_desk" },
    { to: "/broker/messages/archive", label: "Archive", feature: "archive" },
    { to: "/broker/audit", label: "Retention", feature: "retention" },
    { to: "/broker/controls/agents", label: "Agent Controls", feature: "agent_controls" },
  ]);
}
